export const INFO = 'info';
export const SUCCESS = 'success';
export const DANGER = 'danger';
export const WARNING = 'warning';
export const WARNING_WITH_CONFIRMATION = 'warning-with-confirmation';
